import { PurchaseAgentState } from 'src/modules/generated/api';

// Mirrors the BE setting `PurchaseAgentSettings.minRemainingBudget`: an agent with at most this
// budget left is deactivated, so a max budget at or below it would stop the agent before it places a single bid.
export const PURCHASE_AGENT_MIN_REMAINING_BUDGET_EUR = 2000;

// FE-only cap, the BE has no max budget. In EUR so it converts into the budget currency like the min.
export const PURCHASE_AGENT_MAX_BUDGET_EUR = 1000000;

// Minute precision is enough for "last modified" and the cycle start, seconds are noise there.
export const PURCHASE_AGENT_DATE_TIME_FORMAT: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

export type PurchaseAgentAction = 'activate' | 'deactivate' | 'pause' | 'resume';

export const PURCHASE_AGENT_ACTION_TARGET_STATE: Record<PurchaseAgentAction, PurchaseAgentState> = {
  activate: PurchaseAgentState.Activated,
  deactivate: PurchaseAgentState.Deactivated,
  pause: PurchaseAgentState.Paused,
  resume: PurchaseAgentState.Activated,
};

export type PurchaseAgentStateActions = {
  primary: Exclude<PurchaseAgentAction, 'deactivate'>;
  canDeactivate: boolean;
};

export const getStateActions = (state?: PurchaseAgentState): PurchaseAgentStateActions => {
  switch (state) {
    case PurchaseAgentState.Activated:
      return { primary: 'pause', canDeactivate: true };
    case PurchaseAgentState.Paused:
      return { primary: 'resume', canDeactivate: true };
    default:
      return { primary: 'activate', canDeactivate: false };
  }
};
